<ngx-simplebar #simplebarMultimedia class="px-3 mx-n3 mb-2"
    style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));" [options]="{ forceVisible: true }">
    <div class="row position-relative">
        <div class="col-lg-12">

            <div class="card-header"
                [ngClass]="{'pt-0': permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property}">
                <div class="row">
                    <div [ngClass]="{'d-flex justify-content-between align-items-center': filterredVideos?.length > 0 && filterredImages?.length > 0}"
                        class="col-12">
                        <ng-container
                            *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property">
                            <div *ngIf="filterredVideos?.length > 0 && filterredImages?.length > 0 && galleryFilter ==='images'"
                                class="form-check form-switch form-switch-md form-switch-primary">
                                <input id="imageFirst" (change)="multimediaFirst = 1"
                                    [attr.disabled]="multimediaFirst === 1 ? true : null"
                                    class="form-check-input opacity-100" type="checkbox" role="switch"
                                    [checked]="multimediaFirst === 1" />
                                <label for="imageFirst" class="form-check-label text-body opacity-100">
                                    {{'t-show-images-first' | translate}}
                                </label>
                            </div>
                            <div *ngIf="filterredVideos?.length > 0 && filterredImages?.length > 0 && galleryFilter ==='videos'"
                                class="form-check form-switch form-switch-md form-switch-primary">
                                <input id="videoFirst" (change)="multimediaFirst = 2" [checked]="multimediaFirst === 2"
                                    [attr.disabled]="multimediaFirst === 2 ? true : null"
                                    class="form-check-input opacity-100" type="checkbox" role="switch" />
                                <label for="videoFirst" class="form-check-label text-body opacity-100">
                                    {{'t-show-videos-first' | translate}}
                                </label>
                            </div>


                            <button type="button" class="btn btn-outline-primary  float-end btn-sm"
                                (click)="subscribeModal(subscribeDataModal)" *ngIf="galleryFilter ==='videos'">
                                + {{ 't-add' | translate
                                }} {{ 't-m-properties.t-videos' |
                                translate }}
                            </button>
                            <button type="button" class="btn btn-outline-primary float-end btn-sm" (click)="addImage()"
                                *ngIf="galleryFilter ==='images' || galleryFilter ==='plan'">
                                + {{ 't-add' | translate }} {{ 't-m-properties.t-images' |
                                translate }}
                            </button>
                            <input hidden type="file" (change)="onFileChange($event)" id="input-file-img"
                                accept="image/png,image/jpg,image/jpeg,image/webp" multiple />
                        </ng-container>

                    </div>
                </div>
            </div>

            <!-- Preparação das fotos novas: uma de cada vez, com progresso -->
            <div class="multimedia-progress" *ngIf="uploadProgress" role="status" aria-live="polite">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="multimedia-progress-title">
                        <span class="spinner-border spinner-border-sm text-primary me-2" aria-hidden="true"></span>
                        {{ 't-preparing-images' | translate:{ current: uploadProgress.current, total: uploadProgress.total } }}
                    </span>
                    <small class="text-muted text-truncate ms-2 multimedia-progress-name">{{ uploadProgress.name }}</small>
                </div>
                <div class="progress progress-sm">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                        [style.width.%]="uploadProgress.total ? (uploadProgress.current / uploadProgress.total) * 100 : 0"></div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center">
                            <ul class="list-inline categories-filter animation-nav" id="filter">
                                <li class="list-inline-item">
                                    <a class="categories py-1 bg-light" data-filter=".images"
                                        (click)="activeCategory('images')"
                                        [ngClass]="{'active': galleryFilter ==='images'}" style="font-weight: 400;">
                                        <i class="ri-image-fill label-icon align-middle fs-16 me-2"></i>
                                        {{ 't-m-properties.t-images' | translate }}
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="categories py-1 bg-light" data-filter=".videos"
                                        (click)="activeCategory('videos')"
                                        [ngClass]="{'active': galleryFilter ==='videos'}" style="font-weight: 400;">
                                        <i class="ri-video-line label-icon align-middle fs-16 me-2"></i>
                                        {{ 't-m-properties.t-videos' | translate }}
                                    </a>
                                </li>
                                <!-- <li class="list-inline-item"><a class="categories" data-filter=".plan"
                                        (click)="activeCategory('plan')"
                                        [ngClass]="{'active': galleryFilter ==='plan'}">Plan</a></li> -->
                            </ul>
                        </div>

                        <div class="row gallery-wrapper" *ngIf="galleryFilter ==='images'">
                            <!-- Border spinner -->
                            <div class="element-item col-xxl-3 col-xl-4 col-sm-6 project designing development"
                                data-category="designing development" *ngFor="let data of filterredImages; let i=index">
                                <div class="gallery-box card">
                                    <div class="gallery-container">
                                        <a class="image-popup" title="">
                                            <img class="gallery-img img-fluid mx-auto" [src]="data?.img" alt=""
                                                (error)="onImageError($event,data)" />
                                            <div class="gallery-overlay" (click)="open(i)">
                                                <h5 class="overlay-caption">{{data?.caption}}</h5>
                                            </div>
                                        </a>
                                        <!-- Recorte reposto: o servidor volta ao automático ao guardar -->
                                        <span class="badge badge-soft-info gallery-crop-badge"
                                            *ngIf="data?.cropDirty && !data?.crop">
                                            <i class="ri-crop-line align-middle me-1"></i>{{ 't-crop-auto-after-save' | translate }}
                                        </span>
                                        <!-- Regulamento IA da UE (art. 50): marca discreta "IA" sobre a capa; esbatida quando desligada -->
                                        <div class="gallery-ai-control" [class.gallery-ai-control-off]="!data?.isAiGenerated"
                                            (click)="$event.stopPropagation()">
                                            <div class="form-check form-switch form-switch-warning m-0">
                                                <input class="form-check-input" type="checkbox" role="switch"
                                                    id="SwitchAi{{data?.id}}" [ngModel]="data?.isAiGenerated"
                                                    [disabled]="!(permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property)"
                                                    (ngModelChange)="onChangeAiGenerated($event,data)">
                                                <label class="form-check-label" for="SwitchAi{{data?.id}}">IA</label>
                                            </div>
                                            <i class="ri-information-line gallery-ai-info" [ngbTooltip]="'t-ai-image.t-help' | translate"
                                                container="body"></i>
                                        </div>
                                    </div>

                                    <div class="box-content">

                                        <div class="mt-2"
                                            [ngStyle]="{'cursor': permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property?null:'not-allowed'}">
                                            <input class="form-control form-control-sm" type="text"
                                                placeholder="Caption" [ngModel]="data?.caption"
                                                (ngModelChange)="onchangeCaption($event,data)"
                                                [ngStyle]="{'pointer-events': permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property?null:'none'}">
                                        </div>
                                        <!-- Stacks - Horizontal -->
                                        <div class="hstack gap-3 mt-1"
                                            *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property">
                                            <div>
                                                <button type="button"
                                                    class="btn btn-sm btn-outline-danger btn-icon waves-effect waves-light mt-1"
                                                    (click)="deleteImage(data)"><i class="ri-delete-bin-5-line"
                                                        style="font-size: 1rem;"></i></button>
                                            </div>
                                            <div *ngIf="canCrop(data)">
                                                <button type="button"
                                                    class="btn btn-sm btn-outline-primary btn-icon waves-effect waves-light mt-1"
                                                    [class.btn-outline-warning]="isLegacyCrop(data)"
                                                    [ngbTooltip]="isLegacyCrop(data) ? ('t-crop-legacy-limited' | translate) : ('t-crop-image' | translate)"
                                                    container="body"
                                                    (click)="cropImage(data)">
                                                    <i class="ri-crop-line" style="font-size: 1rem;"></i></button>
                                            </div>
                                            <div>
                                                <div class="form-check form-switch form-switch-primary pt-2">
                                                    <input class="form-check-input" type="checkbox" role="switch"
                                                        id="SwitchCheck{{data?.id}}" checked [ngModel]="data?.status"
                                                        (ngModelChange)="onChangeActive($event,data)">
                                                </div>
                                            </div>
                                            <div>
                                                <select class="form-select form-select-sm"
                                                    aria-label=".form-select-sm example"
                                                    (change)="onchangeImageOrder($event, data)">
                                                    <option [attr.selected]="(j+1)===data?.id?true:null"
                                                        *ngFor="let data2 of filterredImages; let j=index"
                                                        [value]="(j+1)">
                                                        {{(j+1)}}º
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end row -->
                        </div>
                        <div class="row gallery-wrapper" *ngIf="galleryFilter ==='videos'">
                            <!-- Border spinner -->
                            <div class="element-item col-xxl-3 col-xl-4 col-sm-6 project designing development"
                                data-category="designing development" *ngFor="let data of filterredVideos; let i=index">
                                <div class="gallery-box card">
                                    <div class="gallery-container">
                                        <a class="image-popup" title="">
                                            <!-- <img class="gallery-img img-fluid mx-auto" src="{{data?.link}}" alt=""
                                                *ngIf="!data?.autoCrop" /> -->
                                            <div class="ratio" style="--vz-aspect-ratio: 67%;">
                                                <iframe [src]="data?.link" title="YouTube video"
                                                    allowfullscreen></iframe>
                                            </div>
                                            <div class="gallery-overlay" (click)="open(i)">
                                                <h5 class="overlay-caption">{{data?.caption}}</h5>
                                            </div>
                                        </a>
                                    </div>

                                    <div class="box-content">

                                        <div class="mt-2 d-none"
                                            [ngStyle]="{'cursor': permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property?null:'not-allowed'}">
                                            <input class="form-control form-control-sm" type="text"
                                                placeholder="Caption"
                                                [ngStyle]="{'pointer-events': permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property?null:'none'}">
                                        </div>
                                        <!-- Stacks - Horizontal -->
                                        <div class="hstack gap-3 mt-1"
                                            *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property">
                                            <div>
                                                <button type="button"
                                                    class="btn btn-sm btn-outline-danger btn-icon waves-effect waves-light mt-1"
                                                    (click)="deleteVideo(data)"><i class="ri-delete-bin-5-line"
                                                        style="font-size: 1rem;"></i></button>
                                            </div>

                                            <div>
                                                <div class="form-check form-switch form-switch-primary pt-2">
                                                    <input class="form-check-input" type="checkbox" role="switch"
                                                        id="SwitchCheck3" checked>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end row -->
                        </div>
                    </div>
                    <!-- end row -->
                </div>
                <!-- ene card body -->
            </div>
            <!-- end card -->

            <!-- end col -->
        </div>
        <!-- <div *ngFor="let data of filterredImages">
            <app-cropperr-developments [imgData]="data" [autoCrop]="true" *ngIf="data?.isNew && data?.autoCrop"></app-cropperr-developments>
        </div> -->
        <app-cropperr-developments></app-cropperr-developments>



        <!-- Subscribe Modal -->
        <ng-template #subscribeDataModal let-modal>
            <div class="modal-content border-0 overflow-hidden">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalFullscreenXxlLabel">Add Video</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body">
                    <div class="input-group py-4">
                        <input type="text" class="form-control" placeholder="link" aria-label="save link"
                            aria-describedby="button-add-video" #newLink>
                        <button class="btn btn-primary" type="button" id="button-add-video"
                            (click)="saveVideo(newLink.value)">Save</button>
                    </div>
                </div>


            </div><!-- /.modal-content -->
        </ng-template>
    </div>
</ngx-simplebar>